import { BaseOption, NestedBaseOption } from '../types';

export const isNestedBaseOption = (
  option: BaseOption | NestedBaseOption,
): option is NestedBaseOption => !!option && 'options' in option;
